<template>
  <div v-if="checkInstructorExist" ref="instructor" class="d-flex justify-content-between">
    <BaseUserProfile :user-name="userFullName(instructor)" :picture="instructor.profile_picture">
      <template slot="name">
        <div class="ml-2">
          <div ref="user--fullname" class="text-primary font-weight-bold">
            {{ userFullName(instructor) }}
          </div>
          <div ref="user--email" class="text-dark mb-2 small">
            {{ instructor.email }}
          </div>
        </div>
      </template>
    </BaseUserProfile>
    <div class="d-flex align-items-center">
      <BaseTag v-if="instructor.tag" ref="tag" :tag="instructor.tag" />
    </div>
  </div>
</template>

<script>
import BaseUserProfile from '@/components/base-components/BaseUserProfile';
import BaseTag from '@/components/base-components/BaseTag';

export default {
  name: 'Instructor',

  components: { BaseUserProfile, BaseTag },

  props: {
    instructor: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    checkInstructorExist() {
      return this.instructor.email != undefined;
    }
  },

  methods: {
    userFullName(user) {
      return `${user.firstname} ${user.lastname}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
